import Link from 'next/link';
import Image from 'next/image';
import {
  hIW2,
  hIW3,
  homeStep3,
  work1,
  work2,
  work3,
  work4,
} from '../../assets/images';
import { Container, Row, Col } from 'react-bootstrap';
import BrandTicker from '../BrandTicker';
import StartTreatmentButton from './StartTreatmentButton';
import { PH_PLACEMENT } from '../../utils/posthogEvents';

const HowItWorks = ({
  path = '/services',
  hide = false,
  steps = theWorks,
  showCTA = true,
  showTicker = true,
  CTAtext = 'Start treatment',
  subtext = 'Ongoing care — without the complexity. Start in minutes. Cancel anytime.',
  supertext = 'Simple 3-Step Process',
}) => {
  return (
    <div className='stepsWrapper'>
      <div className='stepsContainer'>
        {' '}
        <div className='titleWithCta'>
          <div className=' '>
            <p className=' tw-text-ribbon_blue lg:tw-text-xl tw-font-medium'>
              {supertext}
            </p>
            <p className=' tw-font-semibold tw-text-[32px] lg:tw-text-[44px]'>
              {' '}
              How it
              <span className='gradientText   '> works</span>
            </p>

            <p className=' tw-text-base tw-text-doc_gray tw-font-normal tw-mt-4 tw-w-full '>
              {subtext}
            </p>
          </div>
        </div>
        <Container fluid className='px-0'>
          <Row className='g-6 gy-3 row'>
            {steps.map((item, index) => (
              <Col lg={4} key={index} className=''>
                <Row className='px-0 tw-flex tw-flex-col lg:tw-flex-row tw-w-full'>
                  <Col
                    xs={3}
                    lg={12}
                    className='px-0 tw-flex tw-items-center tw-justify-center tw-w-full'
                    //style={{ backgroundColor: 'yellow' }}
                  >
                    <div className='stepImage'>
                      <Image
                        src={item.img}
                        layout='fill'
                        objectFit='contain'
                        alt='step-image'
                        quality={100}
                        objectPosition='center'
                      />
                    </div>
                  </Col>
                  <Col //style={{ backgroundColor: 'orange' }}
                  >
                    <div className='stepSection'>
                      <h4 className='stepTitle  tw-text-center lg:tw-text-left'>
                        {item.id}. {item.title}
                      </h4>
                      <p className='stepBody tw-text-center lg:tw-text-left'>
                        {item.body}
                      </p>
                    </div>
                  </Col>
                </Row>
              </Col>
            ))}
          </Row>
          <div className='tw-mt-6 tw-flex  lg:tw-justify-end'>
            {' '}
            {showCTA && (
              <div className='tw-w-full lg:tw-w-max'>
                <StartTreatmentButton
                  path={path}
                  CTAtext={CTAtext}
                  placement={PH_PLACEMENT.HOW_IT_WORKS}
                />
              </div>
            )}
          </div>
        </Container>
        {showTicker && (
          <div
            style={{ margin: '6rem 0 0rem', width: '-webkit-fill-available' }}
          >
            {hide ? null : <BrandTicker />}
          </div>
        )}
      </div>
    </div>
  );
};

export default HowItWorks;
const theWorks = [
  {
    id: 1,
    img: work1,
    title: 'Complete a Quick Assessment',
    body: (
      <div>
        <p>
          Fill out a short form with your symptoms and basic health information
          so a provider can understand your needs.
        </p>
        <ul className='tw-list-inside tw-text-center lg:tw-text-left '>
          <li>Takes just a few minutes</li>
          <li>Simple, guided questions</li>
          <li>No commitment</li>
        </ul>
      </div>
    ),
  },
  {
    id: 2,
    img: hIW2,
    title: ' Get reviewed by a licensed provider',
    body: (
      <div>
        <p>
          A licensed provider carefully reviews your information and determines
          the appropriate treatment.
        </p>
        <ul className='tw-list-inside tw-text-center lg:tw-text-left '>
          <li>Reviewed by a qualified provider</li>
          <li>No insurance required</li>
          <li>Treatment based on your responses</li>
        </ul>
      </div>
    ),
  },
  {
    id: 3,
    img: homeStep3,
    title: 'Prescription Sent for Pickup',
    body: (
      <div>
        <p>
          If approved, your prescription is sent to your selected pharmacy and
          ready for pickup
        </p>
        <ul className='tw-list-inside tw-text-center lg:tw-text-left '>
          <li>Sent to your preferred pharmacy</li>
          <li>Ready within hours (in most cases)</li>
          <li>Clear next steps for pickup</li>
        </ul>
      </div>
    ),
  },
];
